// extracted by mini-css-extract-plugin
module.exports = {"search-allign":"styles_search-allign__3U8MA","search-Icon":"styles_search-Icon__jp9Z0","input-icon-clear":"styles_input-icon-clear__3Q-LY"};